import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const fontClasses = [
	{
		text: [
			"title-h1",
			"title-h2",
			"title-h3",
			"title-h4",
			"title-h5",
			"title-h6",
			"Subheading-Large",
			"Subheading-Medium",
			"Subheading-Small",
			"Subheading-X-Small",
			"Subheading-2X-Small",
			"Label-X-Large",
			"Label-Large",
			"Label-Medium",
			"Label-Small",
			"Label-X-Small",
			"Paragraph-X-Large",
			"Paragraph-Large",
			"Paragraph-Medium",
			"Paragraph-Medium-Bold",
			"Paragraph-Small",
			"Paragraph-X-Small",
			"Paragraph-X-Small-Bold",
			"Link-X-Large",
			"Link-Large",
			"Link-Medium",
			"Link-Small",
			"Link-X-Small",
			"CTA",
		],
	},
];

const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			"font-size": fontClasses,
			"font-weight": fontClasses,
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
